export const SOURCE_MULTI_SKU_NUM = {
  SHOP_PREVIEW: 0, // 门店预览页多规格浮层入口
  FIXED_PRICE: 1, // 一口价落地页多规格浮层入口
  SHOP_CART_POPUP: 2, // 购物车浮层多规格浮层入口
  NINE_ONE_NINE: 3 // 919活动落地页多规格浮层入口, 其它活动页面需要打开多规格浮层时直接将 number类型的source传进来，不再定义source的值
};

export const SOURCE_ORDER_REQUEST = {
  SHOP_CART_POPUP: 0, //购物车浮层提单
  FIXED_PRICE: 1, // 一口价落地页提单
  NINE_ONE_NINE: 3, // 919活动落地页提单，其它活动页面提单直接将 number类型的source传进来，不再定义source的值
};

// 门店活动类型
export const SHOP_ACTIVITY_TYPE = {
  /** 折扣菜 */
  DISCOUNT_FOOD: 18,
  /** 满折 */
  FULL_DISCOUNT: 3,
  /** 满减 */
  FULL_REDUCE: 2,
};

/**
 * 动画状态
 */
export const ANIM_STATE = {
  START: 'start',
  END: 'end'
};

// 用户获取餐品方式
export enum UserGetMode {
  delivery = 'delivery',
  pickup = 'pickup',
}

/** 规格浮层加购按钮类型 */
export enum ButtonType {
  /** 减 */
  DES = 0,
  /** 加 */
  ADD = 1
}
